<template>
  <div class="home-box">
    <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Activity List</h3>
        <v-spacer></v-spacer>
        <v-autocomplete :items="months" auto-select-first rounded outlined dense hide-details hide-selected
          :item-text="'name'" :item-value="'id'" label="Month" v-model="month"></v-autocomplete>
      </v-card-title>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-list v-if="!loading">
            <v-list-item v-for="(item, index) in list" :key="index">
              <v-list-item-action>
                <v-icon v-if="item.status == 'SUBMITTED'" large
                  :color="getStatusColor(item.status)">mdi-checkbox-marked-circle-outline</v-icon>
                <v-icon v-else-if="item.status == 'PENDING'" large
                  :color="getStatusColor(item.status)">mdi-information</v-icon>
                <v-icon v-else-if="item.status == 'APPROVED'" large
                  :color="getStatusColor(item.status)">mdi-checkbox-marked-circle</v-icon>
                <v-icon v-else large :color="getStatusColor(item.status)">mdi-information</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.activity }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.name }} / {{ formatDate(item.created_at) }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip small class="ma-1" dark :color="getStatusColor(item.status)">
                  {{ item.status || "Not Submitted" }}
                </v-chip>
              </v-list-item-action>

              <v-list-item-action>
                <v-btn color="green" fab x-small dark title="View" @click="manageTasks(item.status, item.uuid, item.key)">
                  <v-icon small> mdi-eye </v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn v-if="item.status == 'REJECTED' || 'SUBMITTED' &&
                  role === 'CLUBS_PERFORMANCE_EVALUATION'
                  " color="red" fab x-small dark title="Delete" @click="deleteActivity(item.uuid, item.key)">
                  <v-icon small> mdi-delete </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list v-if="!list">
            <v-list-item-content>
              <v-list-item-title>Activity not found!</v-list-item-title>
            </v-list-item-content>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pl-5 pr-5">
      <Pagination @previous="page--" @next="page++" :loading="loading" :total="total" :page="Number(page)"></Pagination>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" color="orange" @classSnackbar="closeSnackbar" />
    <ConfirmModal :text="'Do you want to delete this activity?'" :title="'Delete Activity'" :color="'red'"
      :confirmOpen="confirmOpen" @cancelConfirm="cancelConfirm()" @confirm="confirm()"></ConfirmModal>
  </div>
</template>

<script>
import MonthsList from "@/utility/cpeMonths.json";
import moment from "moment";
import { ActivityService } from "../../services/activity-service";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import Pagination from "@/components/shared/Pagination";
import ConfirmModal from "@/components/shared/ConfirmModal";

export default {
  name: "ActivityList",
  components: { Snackbars, Pagination, ConfirmModal },

  data: function () {
    return {
      loading: false,
      filterBtnTTip: false,
      month: "",
      months: MonthsList,
      list: [],
      role: localStorage.getItem("role"),
      errors: null,
      successMsg: "",
      snackbar: false,
      page: null,
      total: 0,
      deleteId: null,
      key: null,
      confirmOpen: false,
    };
  },

  mounted() {
    this.getCurrentMonth();
    this.$store.dispatch("auth/getProfile");
    localStorage.removeItem("maf_contribution_uuid");
    localStorage.removeItem("mjf_contribution_uuid");
    localStorage.removeItem("service_project_uuid");
  },

  watch: {
    month(val) {
      localStorage.setItem("activity_month", val);
      this.page = 1;
      localStorage.setItem("cp_activity_page", 1);
      this.loadTaskList();
    },
    page(val) {
      localStorage.setItem("cp_activity_page", val);
      this.loadTaskList();
    },
  },

  methods: {
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "SUBMITTED":
          bgColor = "blue";
          break;

        case status === "PENDING":
          bgColor = "red";
          break;

        case status === "APPROVED":
          bgColor = "green";
          break;
        default:
          bgColor = "orange";
          break;
      }
      return bgColor;
    },

    loadTaskList() {
      this.page = localStorage.getItem('cp_activity_page') || 1;
      this.loading = true;
      ActivityService.getCpeActivityList(this.month, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.list = response.data.data;
            this.total = response.data.last_page || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.list = [];
        });
    },

    manageTasks(status, mAId, key) {
      if (status === "SUBMITTED" || status === "APPROVED" || status === "REJECTED") {
        this.$router.push(
          "/activities/monthly/view/" + mAId + "/" + this.month + "/" + key
        );
      } else if (
        (this.month < moment().format("MM") && moment().format("MM") > "05") ||
        this.month >= moment().format("MM")
      ) {
        this.redirectTasksManager(status, mAId, key);
      } else {
        this.successMsg = "Previous or future months activities are disabled";
        this.snackbar = true;
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    getCurrentMonth() {
      if (localStorage.getItem("activity_month")) {
        this.month = localStorage.getItem("activity_month");
      } else {
        this.month = moment().format("MM");
      }

      this.loadTaskList();
    },

    redirectTasksManager(status, mAId, key) {
      this.snackbar = false;
      if (status === "PENDING") {
        this.$router.push(
          "/activities/monthly/edit/" + mAId + "/" + this.month + "/" + key
        );
      } else {
        this.$router.push("/activities/monthly/add/" + this.month + "/" + key);
      }
    },

    deleteActivity(id, key) {
      this.deleteId = id;
      this.key = key;
      this.confirmOpen = true;
    },
    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.loading = true;
      ActivityService.deleteCommonActivity(this.deleteId, this.key)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.loadTaskList();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
